import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 3px 0 3px;
`

export const Label = styled.label`
  margin: 0 0.3rem;
  text-transform: capitalize;
`

export const Input = styled.input`
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px;

  ${({ textColor }) =>
    textColor &&
    css`
      color: ${textColor};
    `}

  &:read-only {
    background-color: #f0f0f0;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #2962ff;
  }

  ${({ error }) =>
    error &&
    css`
      box-shadow: 0 0 0.2rem 0.09rem red;
    `}
`

export const Error = styled.p`
  margin: 3px 0 6px 0;
  color: #ab003c;
`
